import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import ParallaxHero from "../components/ParallaxHero";
import HomeAboutPreview from "../components/HomeAboutPreview";
import HomeEventsPreview from "../components/HomeEventsPreview";
import CoursesSection from "../components/CoursesSection";
import DonateSection from "../components/DonateSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import { setupSmoothScrolling } from "../services/scrollService";


const HomePage = () => {
  // Scroll to top and setup smooth scrolling when the page loads
  useEffect(() => {
    window.scrollTo(0, 0);
    setupSmoothScrolling('a[href^="#"]');
  }, []);

  return (
    <div className="overflow-hidden">
      <SEO 
        title="Premier Educational Center Afghanistan"
        description="Join Safir Elite - Afghanistan's leading educational platform offering expert-led courses, events, and academic programs for excellence in education."
        canonical="/"
        ogType="website"
        keywords="educational center, Afghanistan, courses, Kabul, online learning, professional training, Safir Elite"
      />
      <StructuredData type="EducationalOrganization" />
      <StructuredData type="WebSite" />
      <Navbar />
      <ParallaxHero />
      <CoursesSection />
      <HomeEventsPreview />
      <HomeAboutPreview />
      <DonateSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
